import { useEffect, useState } from 'react';
// import Marquee from "react-fast-marquee";
import Carousel from '../../../../components/carousel/Carousel';
// import {
//     motion,
//     useScroll,
//     useSpring,
//     useTransform,
//     useMotionValue,
//     useVelocity,
//     useAnimationFrame
//   } from "framer-motion";

export default function ProjectDetailsCarousell({
    gradientStart = "#FFCF51",
    gradientEnd = "#E6AB46",
    screenshots,
    isVertical = false,
}){

    const [ ready, setReady ] = useState(false);
    const [imageArr, setImageArr] = useState([]);

    useEffect(() => {
        if(screenshots){
            if(screenshots.length > 0){
                let arr = [];

                screenshots.forEach((img) => {
                    arr.push(img.src);
                });


                setImageArr(arr);
                setReady(true)
            }
        };




    }, [screenshots]);
    


    // const baseSpeed = 500;



    if(ready){
        return(
            <>

                <div
                    className="
                        w-screen
                        h-[50svh]
                        md:h-screen
                        flex
                        items-center
                        justify-center
                    "
                    style={{
                        backgroundImage: `linear-gradient(to bottom, ${gradientStart}, ${gradientEnd})`,
                    }}
                >


                    <Carousel 
                        autoplay={true}
                        imageArray={imageArr}
                        isVertical={screenshots[0].isVertical}
                    />


                    {/* <Marquee
                        speed={100}
                    >

                        {
                            screenshots.map((image, index) => {
                                return (
                                    <div
                                        key={"screenshot-" + index}
                                        className={
                                            (image.isVertical?verticalDivClass:horizontalDivClass) + 
                                            `
                                                mx-5
                                                sm:mx-10
                                            `
                                        }
                                    >
                                        <img 
                                            src={image.src}
                                            alt="Goods Screenshot"
                                            className={`
                                                object-contain
                                                ${
                                                    (image.isVertical?  ` h-full`:` w-full`)
                                                }
                                            `}
                                        />
                                    </div>
                                )
                            })
                        }


                    </Marquee> */}




                </div>


            </>
        );

    }

}